import { SegmentEvent } from '@/integrations/segment/SegmentEvent';
import { ViewedStandardTriageSituationPageEventTracking } from '@/modules/auth/models/segmentevents/ViewedStandardTriageSituationPageEventTracking';

export class StandardTriageSituationPageCompletedEventTracking extends ViewedStandardTriageSituationPageEventTracking {
  static eventName: SegmentEvent = SegmentEvent.STANDARD_TRIAGE_SITUATION_PAGE_COMPLETED;
  selection?: string;

  constructor(eventProperties: Partial<StandardTriageSituationPageCompletedEventTracking> = {}) {
    super(eventProperties);
    this.selection = eventProperties?.selection;
  }
}
